import { isMobileApp } from "./mobileAppServices";
import { App } from '@capacitor/app'
import { initialize, SafeArea } from '@capacitor-community/safe-area';

/**
 * Checks for updates and applies them if available.
 */
export async function setSafeAreaInsets(): Promise<void> {

  if (!isMobileApp()) {
    return;
  }

  SafeArea.enable({
    config: {
      offset: 0
    }
  });
  initialize();

  App.addListener('appStateChange', async (state) => {
    if (state.isActive) {
      SafeArea.enable({
        config: {
          offset: 0
        }
      });
      initialize();
    }
  });
  
}

